import { faStopCircle, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Component } from "preact";

export default class Error extends Component {
    render(props) {
        return (
            <>
                <div className="d-flex flex-column text-center justify-content-center align-items-center">
                    <div>
                        <span style={{ "font-size": "10em" }}>
                            <FontAwesomeIcon icon={faTriangleExclamation} />
                        </span>
                    </div>

                    <div>
                        <h1>{props.message ? <>{props.message}</> : "Une erreur est survenue"}</h1>
                    </div>
                </div>
            </>
        );
    }
}
